// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__xOJUN","main":"main__dJln-","block":"block__wp0n+","blockNum":"blockNum__YwQWr","blockBtn":"blockBtn__7IEFt","navBtn":"navBtn__jQR1h"};